import React, { createContext, useContext, useReducer } from "react";
import { initialState, contratosReducer, ContratosState } from "./contratos-reducer";

type ContratosContextType = {
    state: ContratosState;
    dispatch: React.Dispatch<any>;
};

const ContratosContext = createContext<ContratosContextType | undefined>(undefined);

export const ContratosProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(contratosReducer, initialState);

    return (
        <ContratosContext.Provider value={{ state, dispatch }}>
            {children}
        </ContratosContext.Provider>
    );
};

export const useContratosState = () => {
    const context = useContext(ContratosContext);
    if (!context) {
        throw new Error("useContratosState must be used within ContratosProvider");
    }
    return context.state;
};

export const useContratosDispatch = () => {
    const context = useContext(ContratosContext);
    if (!context) {
        throw new Error("useContratosDispatch must be used within ContratosProvider");
    }
    return context.dispatch;
};
